/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

/**
 * Bloques del checkbox "Activos" — clonados del v1 (ER/index.js:4063-4460).
 *
 * Cuatro bloques: Benchmark Inversion, Inversion en Activos, Disponible Acumulado y
 * Valor en Libros, cada uno con su variante de pais unico y de region (Chile+Peru).
 * Se extrajo a componente propio del v2 para no inflar el index; el JSX es el del v1
 * sin cambios.
 */
export const InversionActivosTable = ({
  verChileYPeru,
  verUnitEconomics,
  verInversionActivos,
  selectedYear,
  inversionCollapsed,
  setInversionCollapsed,
  mesesWindowed,
  eMs,
  formatCurrency,
  eBenchmarkInv,
  eInversion,
  eDisponibleInv,
  eValorActivos,
  inversionMensualesCombinados,
  disponibleInversionCombinados,
  valorActivosCombinados,
  benchmarkInversionCombinados,
  verUltimos12Meses,
  meses,
  monthsToShow,
}) => (
  <>
    {!verChileYPeru && !verUnitEconomics && verInversionActivos && (
      <>
        <tr style={{ height: "8px", backgroundColor: "transparent" }}>
          <td colSpan={14} style={{ padding: 0, border: "none" }} />
        </tr>
        {selectedYear >= 2026 && eBenchmarkInv && !inversionCollapsed && (
          <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
            <td
              className={styles.conceptCell}
              style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
            >
              Benchmark Inversión
            </td>
            {mesesWindowed.map((_, index) => {
              const valor = eBenchmarkInv[index];
              return (
                <td
                  key={index}
                  className={styles.valueCell}
                  style={{
                    fontSize: "0.8rem",
                    color: "#a8d8ea",
                    fontWeight: "400",
                    padding: "6px 4px",
                    textAlign: "right",
                  }}
                >
                  {valor === null ? "-" : index < eMs ? formatCurrency(valor, index) : "-"}
                </td>
              );
            })}
            <td
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color: "#a8d8ea",
                fontWeight: "500",
                fontStyle: "normal",
                padding: "6px 8px",
                textAlign: "right",
              }}
            >
              {formatCurrency(
                eBenchmarkInv.slice(0, eMs).reduce((a, b) => a + b, 0),
                null,
                eBenchmarkInv
              )}
            </td>
          </tr>
        )}
        <tr
          style={{
            backgroundColor: "#1a5276",
            fontStyle: "italic",
            cursor: selectedYear >= 2026 ? "pointer" : "default",
            userSelect: "none",
          }}
          onClick={() => selectedYear >= 2026 && setInversionCollapsed(!inversionCollapsed)}
        >
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#fff", fontWeight: "500", fontSize: "0.85rem" }}
          >
            Inversión en Activos {selectedYear >= 2026 && !verUltimos12Meses && inversionCollapsed ? ">" : ""}
          </td>
          {mesesWindowed.map((_, index) => {
            const valor = eInversion[index] || 0;
            return (
              <td
                key={index}
                className={styles.valueCell}
                style={{
                  fontSize: "0.8rem",
                  color: "#fff",
                  fontWeight: "400",
                  padding: "6px 4px",
                  textAlign: "right",
                }}
              >
                {index < eMs ? formatCurrency(valor, index) : "-"}
              </td>
            );
          })}
          <td
            className={styles.valueCell}
            style={{
              fontSize: "0.8rem",
              color: "#fff",
              fontWeight: "500",
              fontStyle: "normal",
              padding: "6px 8px",
              textAlign: "right",
            }}
          >
            {(() => {
              const totalInv = eInversion.slice(0, eMs).reduce((a, b) => a + b, 0);
              const disponible = eDisponibleInv ? eDisponibleInv[Math.min(eMs, 12) - 1] || 0 : 0;
              const base = disponible + totalInv;
              const pct = base > 0 ? ((totalInv / base) * 100).toFixed(0) + "%" : "";
              return `${formatCurrency(totalInv, null, eInversion)}${pct ? ` | ${pct}` : ""}`;
            })()}
          </td>
        </tr>
        {selectedYear >= 2026 && eBenchmarkInv && !inversionCollapsed && (
          <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
            <td
              className={styles.conceptCell}
              style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
            >
              Disponible Acumulado
            </td>
            {mesesWindowed.map((_, index) => {
              const valor = eDisponibleInv[index];
              return (
                <td
                  key={index}
                  className={styles.valueCell}
                  style={{
                    fontSize: "0.8rem",
                    color: valor === null ? "#a8d8ea" : valor >= 0 ? "#66cc99" : "#ff7777",
                    fontWeight: "400",
                    padding: "6px 4px",
                    textAlign: "right",
                  }}
                >
                  {valor === null ? "-" : index < eMs ? formatCurrency(valor, index) : "-"}
                </td>
              );
            })}
            <td
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color: (eDisponibleInv[Math.min(eMs, 12) - 1] || 0) >= 0 ? "#66cc99" : "#ff7777",
                fontWeight: "500",
                fontStyle: "normal",
                padding: "6px 8px",
                textAlign: "right",
              }}
            >
              {formatCurrency(eDisponibleInv[Math.min(eMs, 12) - 1] || 0, Math.min(eMs, 12) - 1)}
            </td>
          </tr>
        )}
      </>
    )}
    {verChileYPeru && !verUnitEconomics && verInversionActivos && (
      <>
        <tr style={{ height: "8px", backgroundColor: "transparent" }}>
          <td colSpan={14} style={{ padding: 0, border: "none" }} />
        </tr>
        {selectedYear >= 2026 && benchmarkInversionCombinados && !inversionCollapsed && (
          <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
            <td
              className={styles.conceptCell}
              style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
            >
              Benchmark Inversión
            </td>
            {meses.map((_, index) => {
              const valor = benchmarkInversionCombinados?.[index] || 0;
              return (
                <td
                  key={index}
                  className={styles.valueCell}
                  style={{
                    fontSize: "0.8rem",
                    color: "#a8d8ea",
                    fontWeight: "400",
                    padding: "6px 4px",
                    textAlign: "right",
                  }}
                >
                  {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
                </td>
              );
            })}
            <td
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color: "#a8d8ea",
                fontWeight: "500",
                padding: "6px 4px",
                textAlign: "right",
              }}
            >
              {formatCurrency(
                (benchmarkInversionCombinados || Array(12).fill(0)).slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                null,
                null,
                true
              )}
            </td>
          </tr>
        )}
        <tr
          style={{
            backgroundColor: "#1a5276",
            fontStyle: "italic",
            cursor: selectedYear >= 2026 ? "pointer" : "default",
            userSelect: "none",
          }}
          onClick={() => selectedYear >= 2026 && setInversionCollapsed(!inversionCollapsed)}
        >
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#fff", fontWeight: "500", fontSize: "0.85rem" }}
          >
            Inversión en Activos {selectedYear >= 2026 && !verUltimos12Meses && inversionCollapsed ? ">" : ""}
          </td>
          {meses.map((_, index) => {
            const valor = inversionMensualesCombinados?.[index] || 0;
            return (
              <td
                key={index}
                className={styles.valueCell}
                style={{
                  fontSize: "0.8rem",
                  color: "#fff",
                  fontWeight: "400",
                  padding: "6px 4px",
                  textAlign: "right",
                }}
              >
                {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
              </td>
            );
          })}
          <td
            className={styles.valueCell}
            style={{
              fontSize: "0.8rem",
              color: "#fff",
              fontWeight: "500",
              padding: "6px 4px",
              textAlign: "right",
            }}
          >
            {formatCurrency(
              (inversionMensualesCombinados || Array(12).fill(0)).slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              null,
              true
            )}
          </td>
        </tr>
        {selectedYear >= 2026 && benchmarkInversionCombinados && !inversionCollapsed && (
          <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
            <td
              className={styles.conceptCell}
              style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
            >
              Disponible Acumulado
            </td>
            {meses.map((_, index) => {
              const valor = disponibleInversionCombinados?.[index] || 0;
              return (
                <td
                  key={index}
                  className={styles.valueCell}
                  style={{
                    fontSize: "0.8rem",
                    color: valor >= 0 ? "#66cc99" : "#ff7777",
                    fontWeight: "400",
                    padding: "6px 4px",
                    textAlign: "right",
                  }}
                >
                  {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
                </td>
              );
            })}
            <td
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color:
                  (disponibleInversionCombinados?.[Math.min(monthsToShow, 12) - 1] || 0) >= 0 ? "#66cc99" : "#ff7777",
                fontWeight: "500",
                padding: "6px 4px",
                textAlign: "right",
              }}
            >
              {formatCurrency(
                disponibleInversionCombinados?.[Math.min(monthsToShow, 12) - 1] || 0,
                Math.min(monthsToShow, 12) - 1,
                null,
                true
              )}
            </td>
          </tr>
        )}
      </>
    )}
    {/* Valor en Libros (Net Book Value) - visible solo con checkbox Activos */}
    {!verChileYPeru && !verUnitEconomics && verInversionActivos && (
      <>
        <tr style={{ height: "4px", backgroundColor: "transparent" }}>
          <td colSpan={14} style={{ padding: 0, border: "none" }} />
        </tr>
        <tr style={{ backgroundColor: "#1a3c5e", fontStyle: "italic" }}>
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#aad4ff", fontWeight: "500", fontSize: "0.85rem" }}
          >
            Valor en Libros de Activos
          </td>
          {mesesWindowed.map((_, index) => {
            const valor = eValorActivos[index] || 0;
            return (
              <td
                key={index}
                className={styles.valueCell}
                style={{
                  fontSize: "0.8rem",
                  color: "#aad4ff",
                  fontWeight: "400",
                  padding: "6px 4px",
                  textAlign: "right",
                }}
              >
                {index < eMs ? formatCurrency(valor, index) : "-"}
              </td>
            );
          })}
          <td
            className={styles.valueCell}
            style={{
              fontSize: "0.8rem",
              color: "#aad4ff",
              fontWeight: "500",
              fontStyle: "normal",
              padding: "6px 8px",
              textAlign: "right",
            }}
          >
            {formatCurrency(eValorActivos[Math.min(eMs, 12) - 1] || 0, Math.min(eMs, 12) - 1)}
          </td>
        </tr>
      </>
    )}
    {verChileYPeru && !verUnitEconomics && verInversionActivos && (
      <>
        <tr style={{ height: "4px", backgroundColor: "transparent" }}>
          <td colSpan={14} style={{ padding: 0, border: "none" }} />
        </tr>
        <tr style={{ backgroundColor: "#1a3c5e", fontStyle: "italic" }}>
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#aad4ff", fontWeight: "500", fontSize: "0.85rem" }}
          >
            Valor en Libros de Activos
          </td>
          {meses.map((_, index) => {
            const valor = valorActivosCombinados?.[index] || 0;
            return (
              <td
                key={index}
                className={styles.valueCell}
                style={{
                  fontSize: "0.8rem",
                  color: "#aad4ff",
                  fontWeight: "400",
                  padding: "6px 4px",
                  textAlign: "right",
                }}
              >
                {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
              </td>
            );
          })}
          <td
            className={styles.valueCell}
            style={{
              fontSize: "0.8rem",
              color: "#aad4ff",
              fontWeight: "500",
              padding: "6px 4px",
              textAlign: "right",
            }}
          >
            {formatCurrency(
              valorActivosCombinados?.[Math.min(monthsToShow, 12) - 1] || 0,
              Math.min(monthsToShow, 12) - 1,
              null,
              true
            )}
          </td>
        </tr>
      </>
    )}
  </>
);
